import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {put, takeLatest} from 'redux-saga/effects';
import common from '../../../../config/common';
import {pathNames as P} from '../../_common/constants/pathnames';

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  RegisterToken: '[Register Token] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  SetUser: '[Set User] Action',
  CatchError: '[Catch Error] Action'
};

const initialAuthState = {
  user: null,
  pages: null,
  accessToken: null,
  refreshToken: null,
  idToken: null,
  expire: null,
  error: null,
  defaultPage: '',
};

const defaultUser = {
  firstName: 'Admin',
  lastName: 'user'
};

export const reducer = persistReducer(
  {
    storage,
    key: 'atzmai-admin-auth',
    whitelist: [
      'user',
      'pages',
      'accessToken',
      'expire',
      'refreshToken',
      'defaultPage'
    ]
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const {tokens, user, pages} = action.payload;
        user.email = user.attributes.email;
        if (!user.attributes.name) {
          user.firstName = defaultUser.firstName;
          user.lastName = defaultUser.lastName;
        } else {
          user.firstName = user.attributes.name;
          user.lastName = user.attributes.family_name || '';
        }
        if (!user.lastName) {
          user.initials = `${user.firstName[0].toUpperCase()}`;
        } else {
          user.initials = `${user.firstName[0].toUpperCase()}${user.lastName[0].toUpperCase()}`;
        }
        user.fullName = `${user.firstName} ${user.lastName}`;

        return {
          ...tokens,
          user: user || defaultUser,
          pages,
          defaultPage: findDefaultPage(pages)
        };
      }

      case actionTypes.RegisterToken: {
        const {accessToken, expire} = action.payload;
        return {...state, accessToken, expire};
      }

      case actionTypes.Logout: {
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const {user} = action.payload;
        return {...state, user};
      }

      case actionTypes.SetUser: {
        const {user} = action.payload;
        return {...state, user};
      }

      case actionTypes.CatchError: {
        const error = `AUTH: ${action.payload.error}`;
        return {...state, error};
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: ({tokens, user, pages}) => ({
    type: actionTypes.Login,
    payload: {tokens, user, pages}
  }),
  registerToken: ({accessToken, expire}) => ({
    type: actionTypes.RegisterToken,
    payload: {accessToken, expire},
  }),
  logout: () => ({type: actionTypes.Logout}),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: {user: user || defaultUser},
  }),
  fulfillUser: (user) => ({type: actionTypes.UserLoaded, payload: {user}}),
  setUser: (user) => ({type: actionTypes.SetUser, payload: {user}}),
  catchError: (error) => ({type: actionTypes.CatchError, payload: {error}}),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });
}

const findDefaultPage = pages => {
  const [pageWithFlagDefault] = pages.filter(page => page.default);

  return Boolean(pageWithFlagDefault)
    ? P[window.innerWidth < 990 ? 'invoiceOrders' : pageWithFlagDefault.pageName]
    : common.defaultPage;
};
